import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { USER_PERMISSIONS_GRANTS_API_ENABLED } from 'src/app/config/permission-source.config';
import {
  UserPermissionGrantDto,
  UserPermissionsResponseDto,
} from './user-permissions.models';

export type { UserPermissionGrantDto } from './user-permissions.models';

/**
 * Kullanıcının anlık izin grant listesi (read/write).
 * GET /api/Identity/UserPermissions
 */
@Injectable({ providedIn: 'root' })
export class UserPermissionsApiService {
  private readonly endpoint = `${environment.apiUrl}/api/Identity/UserPermissions`;

  constructor(private http: HttpClient) {}

  isEnabled(): boolean {
    return USER_PERMISSIONS_GRANTS_API_ENABLED;
  }

  getCurrentUserPermissions(): Observable<UserPermissionsResponseDto | null> {
    if (!this.isEnabled()) {
      return of(null);
    }

    return this.http.get<UserPermissionsResponseDto>(this.endpoint).pipe(
      catchError((err) => {
        console.warn(
          'UserPermissions API failed, falling back to login permissions',
          err,
        );
        return of(null);
      }),
    );
  }

  getCurrentUserGrants(): Observable<UserPermissionGrantDto[]> {
    return this.getCurrentUserPermissions().pipe(
      map((res) => res?.permissions ?? []),
    );
  }
}
